import {environment} from '../../../environments/environment';

export const API_CONFIG = {
  apiBaseUrl: environment.apiBaseUrl,
  getTokenPath: '/v3/getToken',
  getReservationPath: '/v3/getReservation',
  getCountriesPath: '/countries',
  getProvincesPath: '/getProvinces',
  saveFamilyRelationshipsPath: '/saveFamilyRelationships',
  getFamilyRelationshipsPath: '/getFamilyRelationships',
  getCheckInStatusPath: '/v2/statusCheckin',
  getHouseRulesPath: (apartmentId: string | number) => `/v2/apartment/${apartmentId}/houseRules`,
  getHowWorksPath: (apartmentId: string | number) => `/v2/apartment/${apartmentId}/howWorks`,
  getRecommendationsPath: (apartmentId: string | number) => `/apartment/${apartmentId}/recommendations`,
  getDoorsPath: (apartmentId: string | number) => `/apartment/${apartmentId}/getDoors`,
  postOpenDoorPath: '/tesaApi',
  getInfoPath: (apartmentId: string | number) => `/apartment/${apartmentId}/pois`,
  getCheckInsPath: '/getCheckin',
  getCheckinsWithChildrenPath: '/getCheckinsWithChildren',
  setCheckinPath: '/v3/setCheckin',
  getContractTypePath: '/v3/getContractTypes',
  setCheckinMinorPath: '/v3/setCheckin',
  getPaymentCheckinsPath: '/reservation/checkins-addon',
  getPaymentFormPath: '/reservation/addon-payment/payment-form',
  getPaymentStatusPath: '/reservation/addon-payment/payment-status',
  getMarkersPath: (apartmentId: string | number) => `/v2/apartment/${apartmentId}/markers`,
  getApartmentPath: (apartmentId: string | number) => `/v3/apartment/${apartmentId}`,
  setSignature: '/v3/setSignature',
  getBrandingPath: (environment: string) => `/branding?e=${environment}`,
  getMunicipalitiesPath: (province: number) => `/getMunicipalities/${province}`,
};
